import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_FULFILLMENT_BY_CHANNEL = createFcmDetails('promoted_fulfillment_by_channel', {
	owner: 'Site Platform',
	context: 'Onsite & Email Fulfillment',
	description: `Configures the fulfillment of promoted petitions by channel.

	See https://change.atlassian.net/wiki/spaces/PROM/pages/2579169323/Promotion+Fullfillment+Overview+Placements+Levers#Where-do-we-fullfill-promotional-impressions%3F for a list of configurable channels

	- open_rate: The open rate of the email (used in email channels as an approximation of the number of times a petition needs to be included to fulfill a single impression)
	- impressions_remaining_threshold: The number of impressions remaining before a petition is no longer recommended in bulk channels. Configuring a value here will cause the channel to order promoted petitions according to greatest # of impressions remaining.
	- petition_specific_blocklist: Configures petitions that should not be displayed together in the same channel if there is a parent petition. ie. if parent petition is anti-gun laws, child petitions may not be pro-gun laws
	- channel_blocklist: A list of petition IDs that should not be recommended in this channel
	- recommender_traffic_percentage: The percentage of traffic that should utilize the recommender
	- recommender_user_allowlist: A list of user IDs that should be overridden to use the recommender
	- min_recommender_percentage: The minimum percentage of recommendations of the available promoted petitions that can be returned from the service.
	- prioritize_oldest_promotions: If true, petitions with the oldest promotions will be prioritized over newer ones when fulfilling impressions for this channel.
	`,
	template: {
		petition_signer_receipt_email: {
			open_rate: 0.28,
			impressions_remaining_threshold: 1,
			petition_specific_blocklist: {},
			channel_blocklist: [],
			recommender_traffic_percentage: 0,
			recommender_user_allowlist: [],
			min_recommender_percentage: 0.1,
			prioritize_oldest_promotions: false,
		},
		petition_update_email: {
			open_rate: 0.15,
			impressions_remaining_threshold: 1,
			petition_specific_blocklist: {},
			channel_blocklist: [],
			recommender_traffic_percentage: 0,
			recommender_user_allowlist: [],
			min_recommender_percentage: 0.1,
			prioritize_oldest_promotions: false,
		},
	},
	import: false,
});
